import { render, staticRenderFns } from "./RankedBarList.vue?vue&type=template&id=3ba5bfac&scoped=true"
import script from "./RankedBarList.vue?vue&type=script&lang=js"
export * from "./RankedBarList.vue?vue&type=script&lang=js"
import style0 from "./RankedBarList.vue?vue&type=style&index=0&id=3ba5bfac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5bfac",
  null
  
)

export default component.exports